<div class="sidenav">
    <h4>About Us</h4>
    <a href="/about">What it's all about</a>
    <mat-divider></mat-divider>
    <a href="/partners">Friends and Partners</a>
    <mat-divider></mat-divider>
    <a href="/getintouch">Get in touch</a>
    <mat-divider></mat-divider>
    <a style="font-weight: bold; color: #753457;">API docs</a>
  </div>


  <div class="navmobile">
    <h4>About Us</h4>
    <a href="/about">What it's all about</a>
    <mat-divider></mat-divider>
    <a href="/partners">Friends and Partners</a>
    <mat-divider></mat-divider>
    <a href="/getintouch">Get in touch</a>
    <mat-divider></mat-divider>
    <a style="font-weight: bold; color: #753457;">API docs</a>
  </div>

  <div class="center">
    <div>
    <h2 style="text-align: center; align-items: center;">API docs</h2>
    <div class="apirequestmessage">To request an API Key please send an email to <a href="mailto:info@lebtivity.com">info@lebtivity.com</a> and we will get back to you shortly</div>
    <h3 style="color: #753457; margin-top: 40px;">GET /api/v1/events</h3>
    <div>Returns an array of events along with each event's details. The result can be filtered based on the parameters below.
    </div>
    <div>
     <h4 style="color: #753457;">Parameters</h4>
     <b>api_key</b> (required): Your api key <br>
     <div style="padding-top: 15px; padding-bottom: 15px;"><b>since</b> (optional):<br></div>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Type:</b> DateTime<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Format:</b> YYYY-MM-DDTHH:II:SS<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Description:</b> Only send the created_at events since a specific date.<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Example:</b> ?since=2013-06-01T19:00:00<br>
     <div style="padding-top: 15px; padding-bottom: 15px;"><b>limit</b> (optional):<br></div>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Type:</b> Integer<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Default:</b> 50<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Maximum:</b> 200<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Description:</b> Limit the number of events to a specific number.<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Example:</b> ?limit=100<br>
     <div style="padding-top: 15px; padding-bottom: 15px;"><b>offset</b> (optional):<br></div>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Type:</b> Integer<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Default:</b> 0<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Description:</b> Start the results from a specific number and skip the previous ones.<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Example:</b> ?offset=20<br>
     <div style="padding-top: 15px; padding-bottom: 15px;"><b>sort</b> (optional):<br></div>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Type:</b> String<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Possible values:</b> visit | event_name | averate_rating<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Default:</b> visit<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Description:</b> Sort the events based on either popularity, name or rating.<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Example:</b> ?sort=visit<br>
     <div style="padding-top: 15px; padding-bottom: 15px;"><b>category</b> (optional):<br></div>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Type:</b> Integer<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Default:</b> none<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Description:</b> Filter the events by category. Pass an integer to filter by category id.<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Example:</b> ?category=1<br>
     <div style="padding-top: 15px; padding-bottom: 15px;"><b>from_date</b> (optional):<br></div>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Type:</b> Date<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Format:</b> YYYY-MM-DD<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Default:</b> none<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Description:</b> Find the events that occur after a given date.<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Example:</b> ?from_date=2013-01-01<br>
     <div style="padding-top: 15px; padding-bottom: 15px;"><b>to_date</b> (optional):<br></div>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Type:</b> Date<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Format:</b> YYYY-MM-DD<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Default:</b> none<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Description:</b> Find the events that occur before a given date.<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Example:</b> ?to_date=2013-01-01<br>
     <div style="padding-top: 15px; padding-bottom: 15px;"><b>status</b> (optional):<br></div>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Type:</b> String<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Possible values:</b> any | active | cancelled | approved<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Default:</b> any<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Description:</b> Filter events based on status. Events are either `active`, `approved` or `cancelled`.<br>
     &nbsp;&nbsp;&nbsp;&nbsp; <b>Example:</b> ?status=active<br>
     </div>
    </div>
    <h3 style="color: #753457; margin-top: 40px;">GET /api/v1/events/&#123;id&#125;</h3>
    <div>
      Returns the event that matches the provided id.
    </div>
    <h4 style="color: #753457;">Parameters</h4>
    <b>api_key</b> (required): Your api key <br>
    <h4 style="color: #753457;">Example Request</h4>
    <div>
      https://events.globalistic.tech/api/v1/events/3000?api_key=jmXOhO9uhE <br>
        "event": &#123; <br>
        &nbsp;&nbsp;&nbsp;&nbsp;"id": 3000,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"event_name": "Signature du livre \"Kibarouna\" de GisÃ¨le Kayata Eid",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"user_id": 3,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"min_fee": null,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"max_fee": null,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"location": "AÃ©roclub de Beyrouth, Rue Sursock, Beyrouth",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"location_lat": null,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"location_lng": null,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"country": 123,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"website": "",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"description": "Cocktail et signature du livre \"Kibarouna\" de GisÃ¨le Kayata Eid\r\n\r\nLes Editions Tamyras ont le plaisir de vous inviter au lancement du livre  \"Kibarouna, Dialogues avec nos aÃ®nÃ©s\" de GisÃ¨le Kayata Eid.\r\n\r\nTrente et une personnalitÃ©s libanaises nous dÃ©montrent, s'il fallait encore le prouver, que \"nos vieux\" sont nos racines, les balises de nos errances, les phares qui Ã©clairent notre rÃ©alitÃ©. ",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"is_recurring": 0,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"type": "standard",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"status": "active",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"created_at": "2019-01-18T11:33:39.000000Z",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"updated_at": "2020-12-15T07:37:44.000000Z",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"visit": 1,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"extra_url": null,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"average_rating": null,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"country_list": &#123;<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"id": 123,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"countrycode": "LBN",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"countryname": "Lebanon",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"code": "LB",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"created_at": null,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"updated_at": null<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&#125;,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"category_list": [<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"id": 9317,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"event_id": 3000,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"category_id": 3,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"created_at": "2020-11-18T07:44:11.000000Z",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"updated_at": "2020-11-18T07:44:22.000000Z",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"category": &#123;<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"id": 3,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"name": "Arts & Culture",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"url": null,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"position": 0,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"created_at": "2012-04-24T00:00:00.000000Z",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"updated_at": "2012-04-24T00:00:00.000000Z"<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;<br>
        &nbsp;&nbsp;&nbsp;&nbsp;],<br>
        &nbsp;&nbsp;&nbsp;&nbsp;"images": [<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"id": 5277,<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"filename": "storage/content/originals/image_5277.jpg",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"created_at": "2020-11-07T08:58:17.000000Z",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"updated_at": "2020-11-07T08:58:17.000000Z",<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"event_id": 3000<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;<br>
        &nbsp;&nbsp;&nbsp;&nbsp;],<br>
            &nbsp;&nbsp;&nbsp;&nbsp;"event_dates": [<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"id": 8605,<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"event_id": 3000,<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"date": "2012-10-11",<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"start_time": "18:00:00",<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"end_time": "21:00:00",<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"recurring_event_date_id": null,<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"created_at": "2012-10-01T16:11:06.000000Z",<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"updated_at": "2012-10-01T16:11:06.000000Z"<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;<br>
            &nbsp;&nbsp;&nbsp;&nbsp;]<br>
        &#125;<br>
    </div>
  </div>